module.exports = __webpack_public_path__ + "static/media/icn_self_itr.694233ba.svg";